<div
  class="outage-card"
  [class.upgrade]="upgrade()"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="outage-screen-title"
>
  @if (!upgrade()) {
    <div class="top-bar" aria-hidden="true"><div class="bar"></div></div>
  }

  @if (upgrade()) {
    <div class="tile tile-lg rocket-tile" aria-hidden="true">
      <svg class="icon float" width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2.5c3 1.8 4.6 5 4.6 8.4L14.8 16H9.2l-1.8-5.1C7.4 7.5 9 4.3 12 2.5z"></path>
        <circle cx="12" cy="9.5" r="1.6"></circle>
        <path d="M9.2 16l-2 3.2 2.8-.7M14.8 16l2 3.2-2.8-.7M12 18v3"></path>
      </svg>
      <svg class="sparkle tw1" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2z"></path></svg>
      <svg class="sparkle tw2" width="9" height="9" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2z"></path></svg>
      <svg class="sparkle tw3" width="7" height="7" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2z"></path></svg>
    </div>
  } @else if (slow()) {
    <div class="tile tile-sm warning-tile" aria-hidden="true">
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="8.5"></circle><path d="M12 7.5V12l3 2"></path>
      </svg>
    </div>
  } @else {
    <div class="icon-wrap" aria-hidden="true">
      <div class="ring"></div>
      <div class="ring ring2"></div>
      <div class="tile tile-md">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7 18h10.5a4 4 0 0 0 .6-7.96A6 6 0 0 0 6.6 9.2 4.4 4.4 0 0 0 7 18z"></path>
          <g class="refresh"><path d="M10 13.2a2.4 2.4 0 0 1 4.1-1.4"></path><path d="M14.4 10.6v1.4H13"></path></g>
        </svg>
      </div>
    </div>
  }

  <h2 id="outage-screen-title" class="title">{{ title() }}</h2>
  <p class="body">{{ body() }}</p>

  @if (showReason()) {
    <p class="deployment-reason" aria-live="polite" aria-atomic="true">
      <strong>{{ outage.reason().label }}:</strong> {{ outage.reason().text }}
    </p>
  }

  @if (upgrade()) {
    <div class="inline-bar" aria-hidden="true"><div class="bar"></div></div>
    <div class="status caption" aria-live="polite">{{ status() }}</div>
  } @else {
    <div class="status" [class.muted]="slow()" aria-live="polite">
      @if (showDots()) {
        <span class="dots" aria-hidden="true"><span></span><span></span><span></span></span>
      }
      <span>{{ status() }}</span>
    </div>
  }

  @if (slow()) {
    <button
      type="button"
      class="btn primary check-now"
      [disabled]="outage.checkLocked()"
      [attr.aria-busy]="outage.checking()"
      [attr.aria-describedby]="outage.cooling() ? 'outage-check-hint' : null"
      (click)="outage.checkNow()"
    >
      @if (outage.checking()) {
        <svg class="spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.2-8.56"></path></svg>
        <span>{{ copy.checking }}</span>
      } @else {
        <span>{{ copy.checkNow }}</span>
      }
      @if (outage.cooling()) {
        <span class="drain" aria-hidden="true"></span>
      }
    </button>
    @if (outage.cooling()) {
      <span id="outage-check-hint" class="sr-only">{{ copy.availableSoon }}</span>
    }
  }

  @if (exits()) {
    <div class="exits">
      <div class="exits-heading">{{ copy.exitsHeading }}</div>
      <div class="exit-buttons">
        @if (outage.booted()) {
          <button type="button" class="btn secondary" (click)="outage.stopWaiting()">{{ copy.stopWaiting }}</button>
        }
        <button type="button" class="btn secondary" (click)="outage.reload()">{{ copy.reload }}</button>
      </div>
      <div class="note">{{ copy.exitsNote }}</div>
    </div>
  }
</div>
